import { Skeleton } from "../../../../components/ui/skeleton";

// sticky pins a column to the right edge so its action button stays visible without horizontal scroll.
const stickyCls = "sticky right-0 z-10 bg-background border-l border-border/40";

export function Th({ children, align = "left", sticky = false, className = "" }) {
  return (
    <th
      className={
        "border-b border-border/70 px-5 py-3 text-[10px] font-medium uppercase tracking-[1.5px] text-muted-foreground " +
        (align === "right" ? "text-right" : "text-left") +
        (sticky ? " " + stickyCls : "") +
        " " +
        className
      }
    >
      {children}
    </th>
  );
}

export function Td({ children, align = "left", sticky = false, className = "" }) {
  return (
    <td
      className={
        "border-b border-border/40 px-5 py-3.5 text-sm text-foreground " +
        (align === "right" ? "text-right" : "text-left") +
        (sticky ? " " + stickyCls : "") +
        " " +
        className
      }
    >
      {children}
    </td>
  );
}

// Table shell that owns loading skeleton rows so pages stay lean.
export function QueueTable({ columns, isLoading, rows, renderRow, emptyText = "Nothing in this queue." }) {
  return (
    <div className="overflow-x-auto border-t border-border">
      <table className="w-full border-separate border-spacing-0">
        <thead>
          <tr>
            {columns.map((c, i) => (
              <Th key={i} align={c.align} sticky={c.sticky}>
                {c.label}
              </Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading && !rows
            ? Array.from({ length: 6 }).map((_, i) => (
                <tr key={i}>
                  {columns.map((_, j) => (
                    <td key={j} className="border-b border-border/40 px-5 py-3.5">
                      <Skeleton className="h-4 w-24" />
                    </td>
                  ))}
                </tr>
              ))
            : rows?.map(renderRow)}
        </tbody>
      </table>
      {!isLoading && rows && rows.length === 0 ? (
        <p className="px-5 py-16 text-center text-sm text-muted-foreground">
          {emptyText}
        </p>
      ) : null}
    </div>
  );
}
